import React, { useState } from "react";
import { Input, Button, Box, Paper, Divider, IconButton } from "@mui/material";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import { FormHelperText } from "@mui/material";
import { Alert } from "../layout";
import { useEffect } from "react";
import { CloseRounded } from "@mui/icons-material";

export default function InputMultFile(props) {
  const {
    name,
    label,
    onChange,
    error = null,
    values = [],
    rmv,
    src,
    maxUpl = 5,
    maxSize = 3,
  } = props;

  const [files, setFiles] = useState([]);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  const handleFile = (e) => {
    const _files = e.target.files;
    const uplFiles = [];
    if (files.length + _files.length <= maxUpl) {
      Array.from(_files).forEach((file) => {
        if (file.size / 1048576 < maxSize) {
          setFiles((x) => [
            ...x,
            {
              name: file.name,
              lastModified: file.lastModified,
              size: file.size,
            },
          ]);
          uplFiles.push(file);
        } else {
          setAlert({
            isOpen: true,
            type: "warning",
            title: `Maximum Allowed ${maxSize}MB`,
            subTitle: `"${file.name}" size is ${(file.size / 1048576).toFixed(
              2
            )}MB. You can't upload file larger than ${maxSize}MB.`,
          });
        }
      });
      // return files
      onChange && onChange({ name, value: values.concat(uplFiles) });
    } else {
      setAlert({
        isOpen: true,
        type: "warning",
        title: `Maximum Upload ${maxUpl} Files`,
        subTitle: `You have uploaded ${
          files.length
        } images. Now you can upload ${maxUpl - files.length} files`,
      });
    }
    // FOR BUG IN CHROME
    e.target.value = "";
  };

  const handleRmv = (file) => {
    setFiles([...files.filter((j) => j !== file)]);

    rmv && rmv(file);
  };
  // console.log("files: ", files);

  useEffect(() => {
    src && setFiles([...src]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src]);

  return (
    <>
      <Paper className="br-8 gray-color shadow-none bs-secondary">
        <div className="d-grid">
          {files.map((file, i) => (
            <div key={i}>
              <div className="d-flex j-between a-center p-5">
                <span className="mt-0 ml-5 fs-12">
                  <span>File Name:&nbsp;&nbsp;</span>
                  {file.isUploaded ? (
                    <span className="fs-14">{file.name}</span>
                  ) : (
                    <a href={file.fileSrc} target="_blank" rel="noreferrer">
                      {file.name}
                    </a>
                  )}
                </span>
                <div>
                  <IconButton
                    onClick={() => handleRmv(file)}
                    color="error"
                    size="small"
                  >
                    <CloseRounded className="fs-16" />
                  </IconButton>
                </div>
              </div>
              {files.length !== i + 1 && <Divider />}
            </div>
          ))}
        </div>

        <Box className="d-flex p-5">
          <label htmlFor={name} className="w-100pr">
            <Input
              className="d-none"
              accept="image/*"
              id={name}
              onChange={handleFile}
              inputProps={{ multiple: true }}
              type="file"
            />
            <Button
              className="w-100pr"
              startIcon={<DriveFolderUploadIcon />}
              component="span"
              size="small"
            >
              {label}
            </Button>
          </label>
        </Box>
        {error && (
          <FormHelperText sx={{ color: "#d32f2f" }}>{error}</FormHelperText>
        )}
      </Paper>
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
}
